import { DEAL_STAGE, DealStage } from 'models/DealRoom';
import { ListingStage, LISTING_STAGE } from 'models/Listing';

export const FILTER_KEY_TRANSLATIONS: Record<string, string> = {
  from: 'evRange',
  to: 'evRange',
  industry: 'industry',
  location: 'location',
  enterpriseBusinessUnitId: 'businessUnitLC',
};

export const DEAL_STAGE_TRANSLATIONS: Record<DealStage, string> = {
  [DEAL_STAGE.SELLER_LEAD]: 'seller_leadLc',
  [DEAL_STAGE.MANDATED]: 'mandatedLc',
  [DEAL_STAGE.LIVE]: 'liveLc',
  [DEAL_STAGE.UNDER_OFFER]: 'under_offerLc',
  [DEAL_STAGE.UNDER_CONTRACT]: 'contractLc',
  [DEAL_STAGE.SOLD]: 'soldLc',
  [DEAL_STAGE.COMPLETE]: 'completeLc',
  [DEAL_STAGE.LOST]: 'lostLc',
  [DEAL_STAGE.ARCHIVED]: 'archivedLc',
};

export const LISTING_STAGE_TRANSLATIONS: Record<ListingStage, string> = {
  [LISTING_STAGE.NO_LISTING]: '',
  [LISTING_STAGE.DRAFT]: 'draftLC',
  [LISTING_STAGE.PUBLIC]: 'publicLC',
  [LISTING_STAGE.PRIVATE]: 'privateLC',
  [LISTING_STAGE.PAUSED]: 'pausedLC',
  [LISTING_STAGE.ENDED]: 'endedLC',
};
